import React, { useRef } from 'react';
import { Row } from 'reactstrap';
import './file-upload.scss';

import { Input } from 'edozvola-frontend-lib/dist/ui/components';
import axios from 'axios';
import { MAX_FILE_SIZE, messages } from 'app/config/constants';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { FormikProps } from 'formik/dist/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { v4 as uuidv4 } from 'uuid';
import { LoaderWithText } from 'app/shared/loader/loader-with-text';

export interface IMultipleFileUpload {
  allowedExtensions?: string[];
  formik: FormikProps<any>;
  showLoader?: boolean
}

const MultipleFileUpload: React.FC<IMultipleFileUpload> = ({ allowedExtensions, formik, showLoader }) => {
  const allowedFileExtensions = allowedExtensions ?? ['pdf'];

  const selectFileRef = useRef(null);

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const onOpenFileDialogClicked = event => {
    event.stopPropagation();
    event.preventDefault();

    if (selectFileRef.current) {
      selectFileRef.current.click();
    }
  };

  const handleSelectedFiles = (selectedFiles: File[]) => {
    let newState = [...formik.values.files];
    selectedFiles.forEach(file => {
      if (file.size > MAX_FILE_SIZE) {
        showToast(toast.error, messages.FILE_TOO_LARGE);
      } else if (!extensionAllowed(file)) {
        showToast(toast.error, messages.FILE_NOT_PDF);
      } else {
        newState.push({
          file: file,
          fileName: file.name.substring(0, file.name.lastIndexOf('.')) || file.name,
          uuid: uuidv4(),
        });
      }
    });
    formik.setFieldValue('files', newState);
  };

  const extensionAllowed = (file: File) => {
    const extension = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
    return allowedFileExtensions.includes(extension.toLowerCase());
  };

  const handleFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    handleSelectedFiles(Array.from(event.dataTransfer.files));
  };

  const handleFileChange = event => {
    handleSelectedFiles(Array.from(Array.from(event.target.files as FileList)));
    selectFileRef.current.value = '';
  };

  const removeFile = (uuid: string) => {
    formik.setFieldValue(
      'files',
      formik.values.files.filter(file => file.uuid !== uuid),
    );
  };

  const fileNameChanged = (fileIndex: number, fileName: string) => {
    formik.setFieldValue(`files.${fileIndex}.fileName`, fileName);
  };

  return (
    <>
      <>
        {showLoader &&
          <div className={'file-drop-wrapper'}>
            <LoaderWithText loadingText={'Učitavanje priloga u tijeku'}/>
          </div>
        }
        {!showLoader &&
          <div onDrop={handleFileDrop} onDragOver={handleDragOver} onClick={onOpenFileDialogClicked} className="file-drop-wrapper">
            <div className="upload-icon">
              <FontAwesomeIcon icon={'file-alt'} size={'2x'} />
            </div>
            <Row className="upload-text">
              <h6 onClick={onOpenFileDialogClicked}>Povucite datoteku ili kliknite ovdje za učitavanje dokumenta.</h6>
              <span className="file-drop-max-size-text" onClick={onOpenFileDialogClicked}>
                Dozvoljene datoteke: {allowedFileExtensions.map(val => '.' + val).join(', ')}
              </span>
              <span className="file-drop-max-size-text" onClick={onOpenFileDialogClicked}>
                Max veličina datoteke je 100MB
              </span>
            </Row>
          </div>
        }
        <input
          type="file"
          ref={selectFileRef}
          accept={allowedFileExtensions.map(val => '.' + val).join(',')}
          multiple
          onChange={handleFileChange}
          hidden
        />
      </>

      <div>
        <div className="uploaded-files-title-wrapper">
          {formik.values.files.map((file, index) => (
            <div className={'d-flex justify-content-between uploaded-file-item'}>
              <div className={'d-flex flex-row gap-2'}>
                <div className={'center-icon'}>
                  <FontAwesomeIcon icon={'file-pdf'} className={'uploaded-file-icon'} />
                </div>
                <div className={'d-flex flex-column gap-1 mt-3'} style={{ width: '30rem' }}>
                  <Input
                    value={file.fileName}
                    onChange={event => fileNameChanged(index, event.target.value)}
                    error={
                      formik.errors.files && formik.errors.files[index] && formik.errors.files[index].fileName
                        ? formik.errors.files[index].fileName
                        : ''
                    }
                  />
                  <span>{`${Math.round(file.file.size / 1000)} KB`}</span>
                </div>
              </div>
              <div className={'center-icon'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'trash-file-icon'} onClick={() => removeFile(file.uuid)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MultipleFileUpload;
